import { render, staticRenderFns } from "./WorkingGroupChildForm.vue?vue&type=template&id=471a30e0"
import script from "./WorkingGroupChildForm.vue?vue&type=script&lang=js"
export * from "./WorkingGroupChildForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports